import axios from "axios";
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data.user);
      return data.user;
    } catch {
      setUser(false);
      return false;
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setUser(data.user);
    return data.user;
  };
  const register = async (name, email, password, phone, birthdate, acceptTerms) => {
    const { data } = await axios.post(`${API}/auth/register`, { name, email, password, phone, birthdate, accept_terms: !!acceptTerms });
    setUser(data.user);
    return data.user;
  };
  const logout = async () => { await axios.post(`${API}/auth/logout`); setUser(false); };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}
